import { WidgetType } from 'domain/entity/widget';
import WidgetData, { Color, Period, WidgetDataAvailability, WidgetDescription } from 'domain/entity/widgetData';

export type WidgetGaugeData = WidgetData & {
    checkpoints: WidgetChartLimit[];
    comparison: WidgetGaugeComparison;
    gaugeType: string;
    indicator: WidgetGaugeIndicator;
    max: number;
    min: number;
    ranges: WidgetGaugeRange[];
    showAsPercentage: boolean;
    units: string;
};
export class WidgetGaugeComparison {
    constructor(
        readonly color: Color,
        readonly enabled: boolean,
        readonly period: Period,
        public showAsPercentage: boolean,
        readonly value?: number
    ) {}
}
export class WidgetGaugeIndicator {
    constructor(readonly color: Color, readonly value: number, readonly name?: string) {}
}

export class WidgetChartLimit {
    constructor(readonly color: Color, readonly value: number, readonly name?: string) {}
}

export class WidgetGaugeRange {
    constructor(readonly color: Color, readonly from: number, readonly to: number, readonly name: string) {}
}

class GaugeData implements WidgetGaugeData {
    type = WidgetType.GAUGE;

    constructor(
        public checkpoints: WidgetChartLimit[],
        readonly comparison: WidgetGaugeComparison,
        readonly dataAvailability: WidgetDataAvailability,
        readonly description: WidgetDescription,
        readonly gaugeType: string,
        readonly indicator: WidgetGaugeIndicator,
        public max: number,
        public min: number,
        public ranges: WidgetGaugeRange[],
        readonly showAsPercentage: boolean,
        readonly units: string
    ) {}
}

export default GaugeData;
